import { Button, Typography } from "@mui/material";
import React from "react";

const TrainYourAI = ({ onChange, value, loading, handleSubmit }) => {
    const handleChange = (e, index) => {
        const newBenefits = [...value];
        newBenefits[index] = e.target.value;
        onChange(newBenefits);
    };
  return (
    <div style={{ display: "block" }}>
      <Typography sx={{ marginTop: "10px", fontSize: "14px" }} variant="paragraph">
        Configure the key message that will appear on your AI training loading screen
      </Typography>
      <div style={{ width: "100%", marginTop: "10px" }}>
        <input
          type="text"
          placeholder="Add key message here"
          value={value[0]}
          onChange={(e) => handleChange(e, 0)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add key message here"
          value={value[1]}
          onChange={(e) => handleChange(e, 1)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add key message here"
          value={value[2]}
          onChange={(e) => handleChange(e, 2)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add key message here"
          value={value[3]}
          onChange={(e) => handleChange(e, 3)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add key message here"
          value={value[4]}
          onChange={(e) => handleChange(e, 4)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", width: "100%" }}
      >
        <Button
          onClick={handleSubmit}
          disabled={!value || loading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "10px" }}
        >
          save
        </Button>
      </div>
    </div>
  );
};

export default TrainYourAI;
